import { CFPBox } from '@bcp-channels-sharedcomponents-reactjs/cf-proxy';
import { AppLayout, Banner, Footer } from '@components';
import { UIHelper } from '@helpers';
import { ChallengeTypeEnum } from '@types';

import { MultichannelForm, PasswordForm } from './components';
import { UpdateCredentialsScreenProps } from './updateCredentials';

export const UpdateCredentialsScreenMobile = ({ updateCredentialType }: UpdateCredentialsScreenProps) => {
	const updateCredentialsForm = getUpdateCredentialsForm(updateCredentialType);

	return (
		<AppLayout styles={{ overflowY: 'auto', height: '100vh' }}>
			<Banner isCollapsed />

			<CFPBox
				stack
				styles={{
					flex: 1,
					zIndex: 1,
					background: '#fff',
					overflowY: 'auto',
				}}
			>
				{updateCredentialsForm}
			</CFPBox>

			<Footer />
		</AppLayout>
	);
};

const getUpdateCredentialsForm = (updateCredentialType: ChallengeTypeEnum | null | undefined) => {
	const styles = {
		flex: 1,
		padding: UIHelper.rem(48, 24, 48),
		maxWidth: UIHelper.rem(510),
	};

	return updateCredentialType === ChallengeTypeEnum.Password ? (
		<PasswordForm styles={styles} />
	) : (
		<MultichannelForm styles={styles} />
	);
};
